import { useParams } from 'react-router-dom';
import { DocumentCreation } from '../components/CreateDocument/CreateDocument';
import { DocumentTypeWithVirtual, TransactionsRoutes } from 'support/types';
import { useMapVirtualToActualDocumentType } from 'services/documentTypes/documentTypes';
import { routeToPage } from 'support/helpers/navigation/navigation';
import { TFunction } from 'i18next';
import { createHandle } from 'services/breadcrumbs/breadcrumbs';
import { RouteParams } from 'support/helpers/types/types';
import { useDocumentCreationRelationship } from 'support/helpers/relationships/relationships';

export const CreateDocumentFromSource = () => {
  const { id: sourceMessageId, messageType: virtualDocumentType } = useParams<RouteParams<TransactionsRoutes.create>>();
  const nonVirtualDocumentType = useMapVirtualToActualDocumentType(virtualDocumentType as DocumentTypeWithVirtual);
  const relationship = useDocumentCreationRelationship({ sourceMessageId, documentType: nonVirtualDocumentType });

  return (
    <DocumentCreation
      sourceMessageId={sourceMessageId}
      relationship={relationship}
      isProductCatalogRoute={false}
      virtualDocumentType={virtualDocumentType as DocumentTypeWithVirtual}
      documentType={nonVirtualDocumentType}
    />
  );
};

CreateDocumentFromSource.handle = createHandle<unknown, RouteParams<TransactionsRoutes.create>>((params) => ({
  label: (t: TFunction) =>
    t('webedi:createDocument.breadcrumb', {
      documentType: t(`common:messageTypes.singular.${params.messageType}`),
    }),
  to: routeToPage(TransactionsRoutes.create, {
    messageType: params.messageType,
    id: params.id,
  }),
  key: `createDocument`,
}));
